import { apiGet, apiPost } from '../mutator';
import type { Paged, PageQuery, StaffNotification, UnreadCount } from '../types';

/**
 * `/v1/staff-notifications/*` — the bell in the top bar.
 * Mirrors `backend/src/notifications/staff/staff-notifications.controller.ts`.
 *
 * There is no permission key on these routes and there should not be: they only
 * ever return the CALLER's own notifications, and the server additionally drops
 * any whose type the caller no longer has the permission to read.
 */

export function listNotifications(
  query: PageQuery & { unreadOnly?: boolean } = {},
  signal?: AbortSignal,
): Promise<Paged<StaffNotification>> {
  return apiGet<Paged<StaffNotification>>('/staff-notifications', query, signal);
}

export function fetchUnreadCount(signal?: AbortSignal): Promise<UnreadCount> {
  return apiGet<UnreadCount>('/staff-notifications/unread-count', undefined, signal);
}

export function markNotificationRead(id: string): Promise<StaffNotification> {
  return apiPost<StaffNotification>(`/staff-notifications/${encodeURIComponent(id)}/read`);
}

export function markAllNotificationsRead(): Promise<{ updated: number }> {
  return apiPost<{ updated: number }>('/staff-notifications/read-all', {});
}
